import firebase from "../../firebase";

export default function({ officeId, rooms }) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "patientTrackingAdmin",
        funcName: "addRoomsToOffice",
        data: { officeId, rooms }
    });
}
